<template>
  <GoogleSigninGuard>
    <MegaraxAuthGuard>
      <el-container>
        <el-header
          id="site-header"
          height="50px"
          class="flex items-center justify-between flex-wrap"
        >
          <div class="flex items-center">
            <BaseButton
              class="site-header-item hidden-md-and-up"
              size="small"
              variant="text"
              style="font-size: 20px; color: initial"
              @click="
                () => {
                  showSideMenuDrawer = !showSideMenuDrawer;
                }
              "
            >
              <i class="fas fa-bars" />
            </BaseButton>

            <router-link to="/home">
              <img
                class="site-header-item hidden-sm-and-down"
                style="margin: 5px 0px 0px 0px"
                src="@/assets/logo.svg"
                width="118"
                height="30"
                alt="Megarax Logo"
              />
            </router-link>
          </div>

          <SiteSearchBar />

          <UserAvatar class="float-right site-header-item" />
        </el-header>
        <el-container id="main-container">
          <NavSidebar
            class="main-sidebar desktop-main-sidebar hidden-sm-and-down"
          />

          <el-drawer
            :visible.sync="showSideMenuDrawer"
            direction="ltr"
            :withHeader="false"
            size="250px"
          >
            <NavSidebar
              class="main-sidebar"
              @item-click="showSideMenuDrawer = false"
            />
          </el-drawer>

          <div class="content-container">
            <SiteBreadcrumb />
            <el-main>
              <router-view></router-view>
            </el-main>
          </div>
        </el-container>
      </el-container>
    </MegaraxAuthGuard>
  </GoogleSigninGuard>
</template>

<script>
import GoogleSigninGuard from "@/components/GoogleSigninGuard.vue";
import MegaraxAuthGuard from "@/components/MegaraxAuthGuard.vue";
import UserAvatar from "./UserAvatar.vue";
import SiteSearchBar from "@/components/SiteSearchBar.vue";
import SiteBreadcrumb from "./SiteBreadcrumb.vue";
import NavSidebar from "../nav/NavSidebar.vue";

export default {
  name: "DefaultContainer",
  components: {
    MegaraxAuthGuard,
    SiteSearchBar,
    GoogleSigninGuard,
    UserAvatar,
    SiteBreadcrumb,
    NavSidebar,
  },
  data() {
    return {
      showSideMenuDrawer: false,
    };
  },
};
</script>

<style scoped>
#main-container {
  margin-top: 50px;
}

#site-header {
  position: fixed;
  background: white;
  width: 100%;

  border-bottom: 1px var(--border-color-lighter) solid;
}

.main-sidebar {
  position: fixed;
  width: var(--sidebar-width);
  overflow-wrap: normal;
  white-space: pre-wrap;
  height: 100%;
}

.desktop-main-sidebar {
  height: unset;
  top: 50px;
  bottom: 0px;
}

.content-container {
  position: fixed;
  left: var(--sidebar-width);
  right: 0px;
  bottom: 0px;
  top: 50px;
  overflow: auto;
}

.el-main {
  padding: 0px;
}

.app-body {
  overflow: visible;
}

@media screen and (max-width: 991px) {
  .content-container {
    left: 0px;
  }
}
</style>
